import Request from '../components/AxiosInstance';
import { toast } from 'react-toastify';


const login = async (URL, dispatch, loginPayload) => {
	try {
		const data = await Request.post(URL, loginPayload);
		if (data.status === 'Success') {
			dispatch({ type: 'LOGIN_SUCCESS' });
			toast.success('Log in successful');
		} else if (data.status === 'InvalidCredentials') {
			toast.error(data.message);
		} else if (data.status === 'MultipleAccountsExist') {
			toast.info(data.message);
		}
		return data;
	} catch (error) {
		throw new Error(error);
	}
}

export async function codeLogin(dispatch, loginPayload) {
	return await login('/auth/codelogin', dispatch, loginPayload);
}

export async function UnPwLogin(dispatch, loginPayload) {
	return await login('/auth/login', dispatch, loginPayload);
}

export async function signUp(dispatch, signupPayload) {
	try {
		await Request.post('/auth/signup', signupPayload);
		dispatch({ type: 'LOGIN_SUCCESS' });
		toast.success('Your account has been created!');
	} catch (error) {
		throw new Error(error)
	}
}

export async function updateContact(dispatch) {
	try {
		const userInfo = await Request.get('/api/account/info');
		dispatch({ type: 'CONTACT_UPDATE', payload: userInfo});
	} catch (error) {
		throw new Error(error)
	}
}

export function updateVideoCallStatus(dispatch, payload) {
	dispatch({ type: 'HAS_SCHEDULED_CALL', payload: payload});
}

export function setOrgData(dispatch, payload) {
	dispatch({ type: 'SET_ORG_DATA', payload: payload});
}

export async function logout(dispatch, callback = () => {}) {
	await Request.get('/auth/logout');
	dispatch({ type: 'LOGOUT' });
	callback();
}